import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CreditCardIcon from "@mui/icons-material/CreditCard";

const UsuarioCartaoCreditoList = ({ listUsuarioCartaoCredito }) => {
  if (listUsuarioCartaoCredito.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" textAlign="center" py={3}>
        Nenhum cartão cadastrado.
      </Typography>
    );
  }

  return (
    <Stack divider={<Divider />}>
      {listUsuarioCartaoCredito.map((cartao, index) => (
        <Stack key={cartao.codigo ?? index} direction="row" spacing={2} alignItems="center" px={2.5} py={1.5}>
          <CreditCardIcon color="action" />
          <Stack minWidth={0}>
            <Typography variant="body2" fontWeight={500}>
              •••• {cartao.terminoCartao}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Vencimento {cartao.vencimento}
            </Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

export default UsuarioCartaoCreditoList;
